import React, { Component } from "react";
import FilterContent from "./FilterContent";
import PageName from "../common/PageName.js";

class FilterArea extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let { fileFolder, showButtons, formActions, formElements, currentPage } = this.props.parentState;
    return (
      <div className="col-sm-12 noprint" id="formcontentheight">
        <PageName
          parentState={this.props.parentState}
          liftGlobalState={this.props.liftGlobalState}
          liftState={this.props.liftState}
          parentProps={this.props.parentProps}
        />
        {formElements[currentPage].filter && formElements[currentPage].filter.length > 0 &&
          <FilterContent
            parentState={this.props.parentState}
            liftState={this.props.liftState}
            liftGlobalState={this.props.liftGlobalState}
            parentProps={this.props.parentProps}
          />
        }
      </div>
    );
  }
}

export default FilterArea;
